﻿import jquery from 'jquery';
import WindowModal from '../../Global/window-modal';
import HabEvents from '../../Global/habitaclia-events';
import Functions from './functions';
import ModalLegal from './modal-legal';

class ModalAlertaFiltro{

    constructor(modalAlertaFiltroDto){
        this._modalAlertaFiltroDto = modalAlertaFiltroDto;

        if (typeof (Storage) !== "undefined" && !!window.sessionStorage) {
            try { //for safari private
                var testKey = 'test', storage = window.sessionStorage;
                storage.setItem(testKey, '1');
                storage.removeItem(testKey);
                this.hasLocalStorage = true;
            } catch (error) {
                this.hasLocalStorage = false;
            }
        }

        if (this.hasLocalStorage && sessionStorage.getItem('MostrarModalCrearAlertaEnProvinciasEspeciales') === 'true')
        {
            this._showModal();
            ModalLegal.RegisterEvents();
            sessionStorage.setItem('MostrarModalCrearAlertaEnProvinciasEspeciales', false);
        }
    }

    _showModal(){
        var oDialog = new WindowModal();
        oDialog.OnReady(this._bindEventsModalAlertaFiltro.bind(this));
        oDialog.OnDestroy(this._unBindEventsModalAlertaFiltro.bind(this));
        var dataBody = `<div class="titleAlerta"> ${this._modalAlertaFiltroDto.translates.label} </div><form id="idFormModalAlertaFiltro" name="formModalAlertaFiltro" method="post"><input name="mailModalAlertaFiltro" id="idMailModalAlertaFiltro" type="text" maxlength="50" size="30" value="${this._modalAlertaFiltroDto.mailUsuario !== null && this._modalAlertaFiltroDto.mailUsuario.length > 0 ? this._modalAlertaFiltroDto.mailUsuario : this._modalAlertaFiltroDto.translates.escribeTuEmail}"><input type="button" id="idCrearAlertaModalAlertaFiltro" name="crearAlertaModalAlertaFiltro" class="boton" value="${this._modalAlertaFiltroDto.translates.crearAlerta}"><div class="legal-label aviso_legal"><label id="etiquetaAvisoLegalModalAlertaFiltro" for="idCheckLegalModalAlertaFiltro"><input type="checkbox" class="chkbox" value="0"  name="checkLegalModalAlertaFiltro" id="idCheckLegalModalAlertaFiltro"><span>${this._modalAlertaFiltroDto.translates.avisoLegalDescripcion}<a class="aviso_legal usuarios js-legal-aviso-link">${this._modalAlertaFiltroDto.translates.avisoLegalLink}</a> <a class="aviso_legal usuarios jqLinkAvisoLegalUsuarios">${this._modalAlertaFiltroDto.translates.privacidadLegalLink}</a></span></div><input type="hidden" id="id_alerta_origen_8" name="alerta_origen" value="8" /></form>`;
        if(this._modalAlertaFiltroDto.UserIsLogged){
            dataBody = `<div class="titleAlerta"> ${this._modalAlertaFiltroDto.translates.label} </div><form id="idFormModalAlertaFiltro" name="formModalAlertaFiltro" method="post"><input name="mailModalAlertaFiltro" id="idMailModalAlertaFiltro" type="text" maxlength="50" size="30" value="${this._modalAlertaFiltroDto.mailUsuario !== null && this._modalAlertaFiltroDto.mailUsuario.length > 0 ? this._modalAlertaFiltroDto.mailUsuario : this._modalAlertaFiltroDto.translates.escribeTuEmail}"><input type="button" id="idCrearAlertaModalAlertaFiltro" name="crearAlertaModalAlertaFiltro" class="boton" value="${this._modalAlertaFiltroDto.translates.crearAlerta}"><input type="hidden" id="id_alerta_origen_8" name="alerta_origen" value="8" /></form>`;
        }
        return oDialog.CreateWindowModal({
            idSelectorString: 'idHabDialogModalAlertaFiltro',
            dataTitle: `<div class="titleModal"> ${this._modalAlertaFiltroDto.translates.titulo}</div><ul class="textModal">${this._modalAlertaFiltroDto.htmlListaFiltrosActivos}</ul><div class="closeModalAlertaFiltro closeModal"></div>`,
            dataBody: dataBody,
            dataFooter: `<a id="idCerrarModalAlertaFiltro" title="${this._modalAlertaFiltroDto.translates.cerrar}">${this._modalAlertaFiltroDto.translates.cerrar}</a>`
        });
    }

    _bindEventsModalAlertaFiltro() {
        jquery('#idMailModalAlertaFiltro').on('focusin', (e) => {
            e.preventDefault(); 
            if (jquery(e.currentTarget).val() === this._modalAlertaFiltroDto.translates.escribeTuEmail) {
                jquery(e.currentTarget).val('');
            }
        });
        jquery('#idMailModalAlertaFiltro').on('focusout', (e) => {
            e.preventDefault(); 
            if (jquery(e.currentTarget).val() === '') {
                jquery(e.currentTarget).val(this._modalAlertaFiltroDto.translates.escribeTuEmail);
            }
        });
        jquery('.closeModalAlertaFiltro, #idCerrarModalAlertaFiltro').on('click', (e) => {
            e.preventDefault(); 
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
        });
        jquery('#idCrearAlertaModalAlertaFiltro').on('click', (e) => {
            e.preventDefault(); 
            if (document.getElementById('idMailModalAlertaFiltro').value === '' || !Functions.ValidateEmail(document.getElementById('idMailModalAlertaFiltro'))) {
                jquery.publish(HabEvents.EventsEnum.ErroresForm, ['eventAction','form-alerta_primeravez']);
                alert(this._modalAlertaFiltroDto.translates.emailIncorrecto);
                return false;
            }
            if(!this._modalAlertaFiltroDto.UserIsLogged){
                if (!jquery("#idCheckLegalModalAlertaFiltro").prop('checked')) {
                    alert(this._modalAlertaFiltroDto.translates.idErrUncheckedLegal);
                    return false;
                }
                else if (document.getElementById("js-form-alerta-header"))
                {
                    document.getElementById("js-legal-check").value = "si";
                    document.getElementById("js-legal-check").checked = true;
                }
            }
            document.getElementById('js-email-alerta').value = document.getElementById('idMailModalAlertaFiltro').value;
            document.getElementById('id_alerta_origen_6').value = 8;
            if (document.getElementById('idFiltros-alerta') !== null) {
                document.getElementById('idFiltros-alerta').value = '1';
                document.getElementById('idFiltros-alerta').checked = true;
            }
            jquery('#id_guardar_FormAlerta').trigger('click');
            jquery.publish(HabEvents.EventsEnum.CloseWindowModal);
        });
    }

    _unBindEventsModalAlertaFiltro() {
        jquery('#idMailModalAlertaFiltro').off('focusin');
        jquery('#idMailModalAlertaFiltro').off('focusout');
        jquery('.closeModalAlertaFiltro, #idCerrarModalAlertaFiltro').off('click');
        jquery('#idCrearAlertaModalAlertaFiltro').off('click');
    }
}

export default ModalAlertaFiltro;
